import { arrayOf, oneOf, string, shape } from 'prop-types';
import { defaultColors } from 'context/entityContext';

export default arrayOf(
  shape({
    label: string,
    key: string,
    value: string,
    dataColor: oneOf(defaultColors.seriesColors),
  })
);
